module.exports = __webpack_public_path__ + "static/media/green-energy.b09f8e57.svg";